// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"RightSection_skeleton__yYww_"};